// extracted by mini-css-extract-plugin
export var icono__circle = "DetailsItem-module--icono__circle--4d035";
export var item__container = "DetailsItem-module--item__container--2743f";
export var item__description = "DetailsItem-module--item__description--45462";
export var item__name = "DetailsItem-module--item__name--f89d5";